//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
import "../Features/Features.PartGeometryCopySelectBuilderList.js";
import "../no/ObjectList.js";
let d=[[[0,"InterfaceUsageType",1,0],[1,"ObjectList",0,"Features.PartGeometryCopySelectBuilderList",0],[0,"ObjectType",1,0]],[[["objectType"],"CreateSelectionBuilder",{R_:{selectionBuilder:"Features.PartGeometryCopySelectBuilder"}},1,0]],[]];
SPLM.Features.PartGeometryCopyBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PartGeometryCopyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PartGeometryCopyBuilder.Type = Object.freeze({
    "Automatic" : "Automatic", "BodyCollector" : "BodyCollector", "BodyObject" : "BodyObject", "CurveFeature" : "CurveFeature", "Sketch" : "Sketch", "Datum" : "Datum", "Point" : "Point", "CompositeCurve" : "CompositeCurve", "CompositeFace" : "CompositeFace", "Group" : "Group", "Expression" : "Expression", "Pmi" : "Pmi", "Curve" : "Curve", "Face" : "Face", "RoutingObject" : "RoutingObject"});

export default SPLM;